import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import './CategoryNav.css';

function CategoryNav() {
  const [categories, setCategories] = useState([]);

  const getCategoryDisplayName = (category) => {
    const slug = String(category?.slug || '').toLowerCase();
    const name = String(category?.name || '');
    if (slug === 'ujala' || slug === 'rr-news' || /ujala/i.test(name)) return 'RR NEWS';
    return name;
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get('/api/categories');
        if (response.data.success) {
          setCategories(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <nav className="category-nav">
      <div className="container">
        <div className="category-list">
          <Link to="/" className="category-item">
            🏠 होम
          </Link>
          {/* Keep RR Gallery and RR Events at fixed positions */}
          <Link to="/category/ujala-gallery" className="category-item">RR गैलरी</Link>
          <Link to="/category/ujala-events" className="category-item">RR इवेंट्स</Link>
          <Link to="/category/rr-public-news" className="category-item">RR PUBLIC NEWS</Link>
          {categories.map((category) => (
            <Link
              key={category._id}
              to={`/category/${category.slug}`}
              className="category-item"
            >
              {getCategoryDisplayName(category)}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default CategoryNav;
